import { authRoutes } from '@/modules/auth'
import { tertiaryCareMapRoutes } from '@/modules/tertiaryCareMap'

import { accreditedNetworkRoutes } from './accredited-network'
import { channelsRoutes } from './channels'
import { cockpitRoutes } from './cockpit'
import { handoffRoutes } from './handoff'
import { outcomesRoutes } from './outcomes'
import { pelicanoRoutes } from './pelicano'
import { personsRoutes } from './persons'
import { pillarsRoutes } from './pillars/routes'
import { protocolRoutes } from './protocol'
import { secondaryAttentionRoutes } from './secondary-attention'
import { virtualClinicRoutes } from './virtualclinic'
import { wandaRoutes } from './wanda'

export const routes = [
  ...authRoutes,
  {
    path: '/',
    name: 'home',
    component: () =>
      import(
        /* webpackChunkName: "HomeLoader" */
        '@/views/HomeLoader.vue'
      ),
    meta: {
      onlyLoggedIn: true,
      title: 'EHR - Início'
    }
  },
  ...cockpitRoutes,
  ...personsRoutes,
  {
    path: '/:catchAll(.*)',
    redirect: { name: 'home' }
  },
  ...accreditedNetworkRoutes,
  ...channelsRoutes,
  ...wandaRoutes,
  ...protocolRoutes,
  ...handoffRoutes,
  ...pillarsRoutes,
  ...secondaryAttentionRoutes,
  ...outcomesRoutes,
  ...pelicanoRoutes,
  ...tertiaryCareMapRoutes,
  ...virtualClinicRoutes
]
